export default str => ( str.slice(0, 19) ).split(/[- :]/)